import { render } from "./audits.vue?vue&type=template&id=242902ef&scoped=true"
import script from "./audits.vue?vue&type=script&lang=ts"
export * from "./audits.vue?vue&type=script&lang=ts"

import "./audits.vue?vue&type=style&index=0&id=242902ef&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-242902ef"

export default script